// extracted by mini-css-extract-plugin
export default {"gradient__bg":"App_gradient__bg__LnwGg","gradient__text":"App_gradient__text__o1YfY"};